import React from 'react';
import { useSelector } from 'react-redux';

// Components
import AddUserDetails from './AddUserDetails';
import AddUserPermissions from './AddUserPermissions';


export default function Pages() {
  // eslint-disable-next-line no-unused-vars
  const { addUserPage } = useSelector(store => store.modals);
  if (addUserPage === 'info') return (<AddUserDetails />);
  else if (addUserPage === 'permissions') return (<AddUserPermissions />);
}

